import { render, staticRenderFns } from "./AssetCustomization.vue?vue&type=template&id=61693b30&scoped=true&"
import script from "./AssetCustomization.vue?vue&type=script&lang=js&"
export * from "./AssetCustomization.vue?vue&type=script&lang=js&"
import style0 from "./AssetCustomization.vue?vue&type=style&index=0&id=61693b30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61693b30",
  null
  
)

export default component.exports